export default "__VITE_ASSET__BpAozZtz__"